<template>
  <div>
    <div class="breadcrumb">
      <h1 style="color: #AC8400;">Motor Purchases</h1>
    </div>
    <div class="separator-breadcrumb border-top"></div>
    <div class="row mb-4">
      <div class="col-md-12 mb-4">
        <!-- Pending -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Pending
              <!-- <span class="badge badge-pill badge-danger">{{ pending.hasOwnProperty(purchases) ? pending.purchases.length : 0 }}</span> -->
            </h4>
            <p>
              The table below shows the list of pending process motor
              certificates purchased.
            </p>
            <div class="row mb-2">
              <div class="col-3">
                <p>
                  <strong>Per Page: </strong>
                  <u
                    class="u-link"
                    :class="{ 'u-active': pending.per_page == 1 }"
                    @click="changePerPage(1, 'pending')"
                    >1</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': pending.per_page == 5 }"
                    @click="changePerPage(5, 'pending')"
                    >5</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': pending.per_page == 10 }"
                    @click="changePerPage(10, 'pending')"
                    >10</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': pending.per_page == 20 }"
                    @click="changePerPage(20, 'pending')"
                    >20</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': pending.per_page == 50 }"
                    @click="changePerPage(50, 'pending')"
                    >50</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': pending.per_page == 100 }"
                    @click="changePerPage(100, 'pending')"
                    >100</u
                  >
                </p>
                <button class="btn btn-primary" @click="exportAsCsv('pending')">
                  Export as CSV
                </button>
              </div>
              <div class="col-3">
                <strong>Start Date</strong>
                <datepicker
                  format="YYYY-MM-DD"
                  v-model="pending.start_date"
                  width="300px"
                  id="pending_start_date"
                ></datepicker>
              </div>
              <div class="col-3">
                <strong>End Date</strong>
                <datepicker
                  format="YYYY-MM-DD"
                  v-model="pending.end_date"
                  width="300px"
                  id="pending_end_date"
                ></datepicker>
              </div>
              <div class="col-2">
                <input
                  type="text"
                  class="form-control"
                  v-model="pending.certificate_number"
                />
              </div>
              <div class="col-1">
                <button
                  class="btn btn-primary"
                  @click="searchCertificate('pending')"
                >
                  Search
                </button>
              </div>
            </div>
            <h2 class="text-justify" v-if="pending.loading">Loading Table</h2>
            <div class="table-responsive" v-if="!pending.loading">
              <table
                id="pending"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>IC Number</th>
                    <th>Certificate Number</th>
                    <th>Date Purchased</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="purchase in pending.purchases" :key="purchase.no">
                    <td>{{ purchase.no }}</td>
                    <td>{{ purchase.ic_number }}</td>
                    <td>{{ purchase.certificate_number }}</td>
                    <td>
                      {{
                        purchase.purchased_date | moment("Do MMMM YYYY, h:mm a")
                      }}
                    </td>
                  </tr>
                </tbody>
              </table>
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                    <button
                      class="page-link"
                      @click="loadAllMotorCertificates(1, 'pending')"
                    >
                      First
                    </button>
                  </li>
                  <li class="page-item">
                    <button
                      class="page-link"
                      v-if="pending.current_page != 1"
                      @click="
                        loadAllMotorCertificates(
                          pending.current_page - 1,
                          'pending'
                        )
                      "
                    >
                      {{ pending.current_page - 1 }}
                    </button>
                  </li>
                  <li class="page-item">
                    <button
                      class="page-link active"
                      @click="
                        loadAllMotorCertificates(
                          pending.current_page,
                          'pending'
                        )
                      "
                    >
                      {{ pending.current_page }}
                    </button>
                  </li>
                  <li class="page-item">
                    <button
                      class="page-link"
                      v-if="pending.current_page != pending.last_page"
                      @click="
                        loadAllMotorCertificates(
                          pending.current_page + 1,
                          'pending'
                        )
                      "
                    >
                      {{ pending.current_page + 1 }}
                    </button>
                  </li>
                  <li class="page-item">
                    <button
                      class="page-link"
                      @click="
                        loadAllMotorCertificates(pending.last_page, 'pending')
                      "
                    >
                      Last
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>

        <br />
        <!-- Completed -->
        <div class="card text-left">
          <div class="card-body">
            <h4 class="card-title mb-3">
              Completed
              <!-- <span class="badge badge-pill badge-danger">{{ completed.hasOwnProperty(purchases) ? completed.purchases.length : 0 }}</span> -->
            </h4>
            <p>
              The table below shows the list of completed process motor
              certificates purchased.
            </p>
            <div class="row mb-2">
              <div class="col-3">
                <p>
                  <strong>Per Page: </strong>
                  <u
                    class="u-link"
                    :class="{ 'u-active': completed.per_page == 1 }"
                    @click="changePerPage(1, 'completed')"
                    >1</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': completed.per_page == 5 }"
                    @click="changePerPage(5, 'completed')"
                    >5</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': completed.per_page == 10 }"
                    @click="changePerPage(10, 'completed')"
                    >10</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': completed.per_page == 20 }"
                    @click="changePerPage(20, 'completed')"
                    >20</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': completed.per_page == 50 }"
                    @click="changePerPage(50, 'completed')"
                    >50</u
                  >
                  <u
                    class="u-link"
                    :class="{ 'u-active': completed.per_page == 100 }"
                    @click="changePerPage(100, 'completed')"
                    >100</u
                  >
                </p>
                <button
                  class="btn btn-primary"
                  @click="exportAsCsv('completed')"
                >
                  Export as CSV
                </button>
              </div>
              <div class="col-3">
                <strong>Start Date</strong>
                <datepicker
                  format="YYYY-MM-DD"
                  v-model="completed.start_date"
                  width="300px"
                  id="completed_start_date"
                ></datepicker>
              </div>
              <div class="col-3">
                <strong>End Date</strong>
                <datepicker
                  format="YYYY-MM-DD"
                  v-model="completed.end_date"
                  width="300px"
                  id="completed_end_date"
                ></datepicker>
              </div>
              <div class="col-2">
                <input
                  type="text"
                  class="form-control"
                  v-model="completed.certificate_number"
                />
              </div>
              <div class="col-1">
                <button
                  class="btn btn-primary"
                  @click="searchCertificate('completed')"
                >
                  Search
                </button>
              </div>
            </div>
            <h2 class="text-justify" v-if="completed.loading">Loading Table</h2>
            <div class="table-responsive" v-if="!completed.loading">
              <table
                id="completed"
                class="display table table-striped table-bordered"
                style="width:100%; text-align: center;"
              >
                <thead>
                  <tr>
                    <th>No.</th>
                    <th>Agent Name</th>
                    <th>IC Number</th>
                    <th>Certificate Number</th>
                    <th>Date Purchased</th>
                    <th>Date Completed</th>
                    <th>Time Difference</th>
                    <th>SPD Reference Number</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="purchase in completed.purchases"
                    :key="purchase.no"
                  >
                    <td>{{ purchase.no }}</td>
                    <td>{{ purchase.agent_name }}</td>
                    <td>{{ purchase.ic_number }}</td>
                    <td>{{ purchase.certificate_number }}</td>
                    <td>
                      {{
                        purchase.purchased_date | moment("Do MMMM YYYY, h:mm a")
                      }}
                    </td>
                    <td>
                      {{
                        purchase.completed_date | moment("Do MMMM YYYY, h:mm a")
                      }}
                    </td>
                    <td>{{ getTimeDifference(purchase) }}</td>
                    <td>{{ purchase.spd_reference_number }}</td>
                  </tr>
                </tbody>
              </table>
              <nav aria-label="Page navigation example">
                <ul class="pagination">
                  <li class="page-item">
                    <button
                      class="page-link"
                      @click="loadAllMotorCertificates(1, 'completed')"
                    >
                      First
                    </button>
                  </li>
                  <li class="page-item">
                    <button
                      class="page-link"
                      v-if="completed.current_page != 1"
                      @click="
                        loadAllMotorCertificates(
                          completed.current_page - 1,
                          'completed'
                        )
                      "
                    >
                      {{ completed.current_page - 1 }}
                    </button>
                  </li>
                  <li class="page-item">
                    <button
                      class="page-link active"
                      @click="
                        loadAllMotorCertificates(
                          completed.current_page,
                          'completed'
                        )
                      "
                    >
                      {{ completed.current_page }}
                    </button>
                  </li>
                  <li class="page-item">
                    <button
                      class="page-link"
                      v-if="completed.current_page != completed.last_page"
                      @click="
                        loadAllMotorCertificates(
                          completed.current_page + 1,
                          'completed'
                        )
                      "
                    >
                      {{ completed.current_page + 1 }}
                    </button>
                  </li>
                  <li class="page-item">
                    <button
                      class="page-link"
                      @click="
                        loadAllMotorCertificates(
                          completed.last_page,
                          'completed'
                        )
                      "
                    >
                      Last
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
    <br />
    <br />
    <br />
    <br />
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import Datepicker from "vuejs-datetimepicker";
import FileDownload from "js-file-download";

export default {
  name: "motor_purchases",
  components: {
    Datepicker
  },
  data() {
    return {
      pending: {
        purchases: [],
        total: 0,
        per_page: 10,
        last_page: 0,
        current_page: 1,
        start_date: moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        certificate_number: "",
        loading: true
      },
      completed: {
        purchases: [],
        total: 0,
        per_page: 10,
        last_page: 0,
        current_page: 1,
        start_date: moment()
          .subtract(30, "days")
          .format("YYYY-MM-DD"),
        end_date: moment().format("YYYY-MM-DD"),
        certificate_number: "",
        loading: true
      }
    };
  },

  methods: {
    loadAllMotorCertificates(page, status) {
      this[status].loading = true;
      this[status].current_page = page;
      let token = localStorage.getItem("token");

      let start_number = 1 + (page - 1) * this[status].per_page;
      let end_number = page * this[status].per_page;
      let start_date = this[status].start_date;
      let end_date = this[status].end_date;
      let certificate_number = this[status].certificate_number;

      let url_string = `?start_number=${start_number}&end_number=${end_number}&status=${status}&start_date=${start_date}&end_date=${end_date}&certificate_number=${certificate_number}`;

      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(`/premia/tba/motor/all_motor_certificates${url_string}`, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            let data = res.data;
            this[status].purchases = data.certificates;
            this[status].total = data.total;
            this[status].last_page = Math.ceil(
              this[status].total / this[status].per_page
            );
            this[status].loading = false;
          })
          .catch(err => {
            this[status].loading = false;
          });
      }
    },
    exportAsCsv(status) {
      let token = localStorage.getItem("token");

      let start_number = 1;
      let end_number = 1000;
      let start_date = this[status].start_date;
      let end_date = this[status].end_date;

      let url_string = `?start_number=${start_number}&end_number=${end_number}&status=${status}&start_date=${start_date}&end_date=${end_date}&export=${true}`;

      //check if has token
      if (token !== null) {
        token = JSON.parse(token);
        token = token.access_token;

        axios
          .get(`/premia/tba/motor/all_motor_certificates${url_string}`, {
            headers: {
              Authorization: "Bearer " + token
            }
          })
          .then(res => {
            let file_name = `${status}_motor_${Date.now()}.csv`;
            FileDownload(res.data, file_name);
          });
      }
    },

    changePerPage(per_page, status) {
      this[status].per_page = per_page;
      this.loadAllMotorCertificates(1, status);
    },

    searchCertificate(status) {
      this.loadAllMotorCertificates(1, status);
    },

    getTimeDifference(purchase) {
      let purchased_date = new Date(purchase.purchased_date);
      let completed_date = new Date(purchase.completed_date);

      let mins = moment
        .utc(
          moment(completed_date, "DD/MM/YYYY HH:mm:ss").diff(
            moment(purchased_date, "DD/MM/YYYY HH:mm:ss")
          )
        )
        .format("HH:mm:ss");

      let day = moment(completed_date).diff(moment(purchased_date), "days");

      let time = day + " day(s) " + mins;

      return time;
    },

    dateSelected(e) {
      console.log(this.pending.start_date);
      this.$nextTick(() => console.log(this.pending.start_date));
    }
  },

  watch: {
    "pending.start_date": {
      handler: function(after, before) {
        this.loadAllMotorCertificates(1, "pending");
      },
      deep: true
    },
    "pending.end_date": {
      handler: function(after, before) {
        this.loadAllMotorCertificates(1, "pending");
      },
      deep: true
    },
    "completed.start_date": {
      handler: function(after, before) {
        this.loadAllMotorCertificates(1, "completed");
      },
      deep: true
    },
    "completed.end_date": {
      handler: function(after, before) {
        this.loadAllMotorCertificates(1, "completed");
      },
      deep: true
    }
  },

  mounted() {
    this.loadAllMotorCertificates(1, "pending");
    this.loadAllMotorCertificates(1, "completed");
  }
};
</script>

<style scoped>
.page-link.active {
  background: #ac8400;
  color: white;
}

u {
  margin-left: 0.1em;
  margin-right: 0.1em;
}

.u-active {
  color: #ac8400;
}

.u-link {
  cursor: pointer;
}
</style>
